<template>
  <div>
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
      <div :class="'input-group'">
        <v-card
          elevation="0"
          style="border: 1px solid rgba(26,26,26,0.2);margin:5px;"
          :class="{ 'sign_error': ['declined', 'autoresponded'].includes((answer.signing_status || '').toLowerCase()), 'signing': ['sent', 'delivered', 'faxpending'].includes((answer.signing_status || '').toLowerCase())}"
        >
          <v-card-text>
            <v-layout
              row wrap
            >
              <v-flex
                sm6
              >
                <v-text-field
                  v-model="value.name"
                  v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
                  :rules="isRequired ? [v => !!v || 'Required'] : []"
                  :disabled="readonly"
                  :aria-label="fieldType.text || question.text"
                  browser-autocomplete="off"
                  label="Signer's Name (John Doe)"
                  @focus="focus"
                  @blur="validateEsign"
                >
                  <v-icon
                    v-if="answer.status"
                    slot="prepend"
                  >
                    {{ statusIconClass }}
                  </v-icon>
                </v-text-field>
              </v-flex>

              <v-flex
                sm6
              >
                <v-text-field
                  v-model="value.email"
                  v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
                  :rules="isRequired ? [v => !!v || 'Required', v => emailRegex.test(v) || 'Email must match this format: <username>@<provider.com>'] : value.email ? [v => emailRegex.test(v) || 'Email must match this format: <username>@<provider.com>'] : []"
                  :disabled="readonly"
                  :aria-label="fieldType.text || question.text"
                  browser-autocomplete="off"
                  label="Signer's Email (username@provider.com)"
                  @focus="focus"
                  @blur="validateEsign"
                />
              </v-flex>
              <v-flex
                v-if="answer.signing_status"
                sm12
              >
                <span>
                  <v-icon
                    left
                    size="16"
                  >
                    mdi-signature-freehand
                  </v-icon>
                  <b>Status: </b> {{getSignResponse(answer.signing_status)}}
                </span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'AltEsignAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: {
        email: null,
        name: null
      },
      savedValue: {
        email: null,
        name: null
      },
      failed: false,
      emailRegex: /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,      
    }
  },
  beforeMount () {
    this.value = {
      name: this.answer.name || null,
      email: this.answer.email || null
    }
    this.savedValue = JSON.parse(JSON.stringify(this.value))
  },
  computed: {
    valueChanged () {
      return (
        this.value.name !== this.savedValue.name ||
        this.value.email !== this.savedValue.email
      )
    },
    highlightNoAnswer () {
      return (!this.value.name && this.value.email && this.formSubmissionAttempt && this.isRequired) || (this.formSubmissionAttempt && !this.valid)
    },
  },
  methods: {
    validateEsign () {
      if (this.value.email && this.value.name)
        this.save()
      if (!this.value.email && !this.value.name)
        this.save()
    }
  }
}
</script>

<style>
  .sign_error {
    border: 3px solid red !important;
    background: rgba(255, 217, 0, 0.5) !important;
  }

  .signing {
    background: rgba(255, 217, 0, 0.1) !important;
  }
</style>